import { render, staticRenderFns } from "./StatusPost.vue?vue&type=template&id=4cf705d8&"
import script from "./StatusPost.vue?vue&type=script&lang=js&"
export * from "./StatusPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports